import i18n from 'i18next';

/**
 * 根据当前语言设置 HTML 文档的语言相关属性
 */
export const setDocumentLanguage = (language?: string) => {
  const currentLanguage = language || i18n.language;

  // 设置 html lang 属性
  document.documentElement.lang = currentLanguage;

  // 设置 meta language 标签
  let metaLanguage = document.querySelector('meta[name="language"]');
  if (!metaLanguage) {
    metaLanguage = document.createElement('meta');
    metaLanguage.setAttribute('name', 'language');
    document.head.appendChild(metaLanguage);
  }
  metaLanguage.setAttribute('content', currentLanguage);

  // 设置 Open Graph locale
  let ogLocale = document.querySelector('meta[property="og:locale"]');
  if (!ogLocale) {
    ogLocale = document.createElement('meta');
    ogLocale.setAttribute('property', 'og:locale');
    document.head.appendChild(ogLocale);
  }

  // 根据语言设置对应的 locale
  const localeMap: Record<string, string> = {
    en: 'en_US',
    zh: 'zh_CN',
    'zh-CN': 'zh_CN',
    'zh-TW': 'zh_TW',
    'zh-HK': 'zh_HK',
  };

  ogLocale.setAttribute('content', localeMap[currentLanguage] || 'en_US');

  // 设置 body 的 CSS class
  const body = document.body;

  // 移除之前的语言 class
  body.classList.remove('lang-en', 'lang-zh', 'lang-zh-cn', 'lang-zh-tw', 'lang-zh-hk');

  // 添加当前语言的 class
  const languageClass = `lang-${currentLanguage.toLowerCase().replace('_', '-')}`;
  body.classList.add(languageClass);

  // 添加是否为中文的 class，方便样式判断
  const isChinese = ['zh', 'zh-CN', 'zh-Hans', 'zh-Hant', 'zh-TW', 'zh-HK'].some((lang) =>
    currentLanguage.toLowerCase().startsWith(lang.toLowerCase()),
  );

  if (isChinese) {
    body.classList.add('is-chinese');
  } else {
    body.classList.remove('is-chinese');
  }

  // 添加是否为英文的 class
  if (currentLanguage.toLowerCase().startsWith('en')) {
    body.classList.add('is-english');
  } else {
    body.classList.remove('is-english');
  }

  console.log(`Document language set to: ${currentLanguage}`);
};

/**
 * 获取当前语言信息
 */
export const getCurrentLanguage = () => i18n.language;

/**
 * 判断是否为中文
 */
export const isChinese = () => {
  const currentLang = getCurrentLanguage();
  return ['zh', 'zh-CN', 'zh-Hans', 'zh-Hant', 'zh-TW', 'zh-HK'].some((lang) =>
    currentLang.toLowerCase().startsWith(lang.toLowerCase()),
  );
};

/**
 * 判断是否为英文
 */
export const isEnglish = () => {
  const currentLang = getCurrentLanguage();
  return currentLang.toLowerCase().startsWith('en');
};

/**
 * 获取语言显示名称
 */
export const getLanguageDisplayName = (langCode?: string) => {
  const lang = langCode || getCurrentLanguage();
  const languageMap: Record<string, string> = {
    en: 'English',
    zh: '中文',
    'zh-CN': '简体中文',
    'zh-TW': '繁體中文',
    'zh-HK': '繁體中文（香港）',
  };
  return languageMap[lang] || lang;
};
